import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry, catchError, map } from 'rxjs/operators';
import { Observable, throwError, of } from 'rxjs';
import { AlertService } from '@app/_services';
import { OwnerLeadProfile } from './owner-lead-profile';
import { SharedService } from './../_shared/shared.service';
import { BizdevLookupService } from '@app/_components/bizdev-lookup/bizdev-lookup.service';

@Injectable({ providedIn: 'root' })
export class OwnerLeadProfileService {

	ownershipCompanies = [
		{ value: 'Prospective Buyer', name: 'Prospective Buyer', id: 1 },
		{ value: 'Alii Beach Rentals', name: 'Alii Beach Rentals', id: 2 },
		{ value: 'Aloha Condos', name: 'Westgate', id: 3 },
		{ value: 'Aqua-Aston', name: 'Aloha Condos', id: 4 },
		{ value: 'Castle Resorts', name: 'Castle Resorts', id: 5 },
		{ value: 'Chase N Rainbows', name: 'Chase N Rainbows', id: 6 },
		{ value: 'Coconut Condos', name: 'Coconut Condos', id: 7 },
		{ value: 'Coldwell Banker Island Vacations', name: 'Coldwell Banker Island Vacations', id: 8 },
		{ value: 'Coral Tree Residences', name: 'Coral Tree Residences', id: 9 },
		{ value: 'Destination Residences', name: 'Destination Residences', id: 10 },
		{ value: 'Elite Pacific', name: 'Elite Pacific', id: 11 },
		{ value: 'Gather', name: 'Gather', id: 12 },
		{ value: 'Hawaii Life', name: 'Hawaii Life', id: 13 },
		{ value: 'iTrips', name: 'iTrips', id: 14 },
		{ value: 'Kona Coast Vacations', name: 'Kona Coast Vacations', id: 15 },
		{ value: 'Maui Condo and Car', name: 'Maui Condo and Car', id: 16 },
		{ value: 'Maui Condo and Home', name: 'Maui Condo and Home', id: 17 },
		{ value: 'Maui Life Vacations', name: 'Maui Life Vacations', id: 18 },
		{ value: 'Maui Paradise Properties', name: 'Maui Paradise Properties', id: 19 },
		{ value: 'Maui Rental Group', name: 'Maui Rental Group', id: 20 },
		{ value: 'Maui Resort Rentals', name: 'Maui Resort Rentals', id: 21 },
		{ value: 'My Perfect Stays', name: 'My Perfect Stays', id: 23 },
		{ value: 'Ola Properties', name: 'Ola Properties', id: 24 },
		{ value: 'Outrigger', name: 'Outrigger', id: 25 },
		{ value: 'PMI Maui', name: 'PMI Maui', id: 26 },
		{ value: 'Quam Properties', name: 'Quam Properties', id: 27 },
		{ value: 'Rentals Maui', name: 'Rentals Maui', id: 28 },
		{ value: 'Vacation Maui', name: 'Vacation Maui', id: 29 },
		{ value: 'Avant Stay', name: 'Avant Stay', id: 30 },
		{ value: 'Casago', name: 'Casago', id: 31 },
		{ value: 'Evolve Vacation Rentals', name: 'Evolve Vacation Rentals', id: 32 },
		{ value: 'Grand Welcome', name: 'Grand Welcome', id: 33 },
		{ value: 'On-Site Management', name: 'On-Site Management', id: 34 },
		{ value: 'Self-Managed', name: 'Self-Managed', id: 35 },
		{ value: 'Vacasa', name: 'Vacasa', id: 36 },
		{ value: 'Abode Park City', name: 'Abode Park City', id: 37 },
		{ value: 'All Park City Rentals', name: 'All Park City Rentals', id: 38 },
		{ value: 'All Seasons Resort Lodging', name: 'All Seasons Resort Lodging', id: 39 },
		{ value: 'Alpine Ski Properties', name: 'Alpine Ski Properties', id: 40 },
		{ value: 'Local Vacation Rentals', name: 'Local Vacation Rentals', id: 41 },
		{ value: 'Luxe Haus', name: 'Luxe Haus', id: 42 },
		{ value: 'Moose Management Vacation Rentals', name: 'Moose Management Vacation Rentals', id: 43 },
		{ value: 'Park City Canyons', name: 'Park City Canyons', id: 44 },
		{ value: 'Park City Host', name: 'Park City Host', id: 45 },
		{ value: 'Park City Lodging', name: 'Park City Lodging', id: 46 },
		{ value: 'Park City Rental Properties', name: 'Park City Rental Properties', id: 47 },
		{ value: 'SkyRun Vacation Rentals', name: 'SkyRun Vacation Rentals', id: 48 },
		{ value: 'Other', name: 'Other', id: 49 },
	];


	leadStatuses = [
		{ name: 'Prospect', value: 1 }, // no contact made
		{ name: 'Lead', value: 2 }, // contact made
		{ name: 'Opportunity', value: 3 }, // in discussions
		{ name: 'Win', value: 4 },
		{ name: 'Loss', value: 5 },
		{ name: 'Contact', value: 6 },
		{ name: 'Do Not Want', value: 7 },
	];

	// QA Complete
	probabilitiesList = [
		{ name: 'Unknown', value: 0 },
		{ name: 'Not Interested', value: 1 },
		{ name: 'Cold', value: 2 },
		{ name: 'Warm', value: 3 },
		{ name: 'Interested', value: 4 },
		{ name: 'Likely Win', value: 5 },
	];

	// QA Complete
	ownershipInterests = [
		{ name: 'Owner', value: 1 },
		{ name: 'Buyer', value: 2 },
		{ name: 'Realtor - Seller', value: 3 },
		{ name: 'Realtor - Buyer', value: 4 },
		{ name: 'Other', value: 5 },
	];

	winReasons = [
		{ name: 'Win From competitor', value: 1 },
		{ name: 'New purchase/Exist Competitor', value: 2 },
		{ name: 'New purchase/Not Rented', value: 3 },
		{ name: 'Former Self Renter', value: 4 },
	];

//   winReasons = [
//     { name: 'From competitor', value: 'comp' },
//     { name: 'New purchase/Exist Competitor', value: 'purch-comp' },
//     { name: 'New purchase/Not Rented', value: 'purch-vacant' },
//     { name: 'From Self Renting', value: 'self-rent' },
//   ];


//   lossReasons = [
//     { name: 'To competitor in sale', value: 'comp-sale' },
//     { name: 'To competitor no sale', value: 'comp' },
//     { name: 'Self-renting', value: 'self-rent' },
//     { name: 'Fired', value: 'fire' },
//   ];

  lossReasons = [
    { name: 'To competitor in sale', value: 1 },
    { name: 'To competitor no sale', value: 2 },
    { name: 'Self-renting', value: 3 },
    { name: 'Fired', value: 4 },
  ];

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService,
			private bizdevLookupService: BizdevLookupService,
		) { }

	getCompetitors(): Observable<{ value: string; name: string; id?: number }[]> {
		return this.bizdevLookupService.getByCategory('COMPETITOR').pipe(
			map(items => items.length > 0
				? items.map(i => ({ value: i.value, name: i.label, id: i.id }))
				: this.ownershipCompanies
			),
			catchError(() => of(this.ownershipCompanies))
		);
	}

	urlEndpoint = 'owner-lead-profiles';

	add(ownerLeadProfile: OwnerLeadProfile): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(ownerLeadProfile));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, ownerLeadProfile);
	}

	update(ownerLeadProfile: OwnerLeadProfile): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, ownerLeadProfile);
	}

	addOwnerPropertyDetails(ownerLeadProfile: OwnerLeadProfile): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(ownerLeadProfile));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/ownerlead-propertylead`, ownerLeadProfile).pipe();
	}

	updateOwnerPropertyDetails(ownerLeadProfile: OwnerLeadProfile): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(ownerLeadProfile));
		return this.http.put<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/ownerlead-propertylead`, ownerLeadProfile).pipe();
	}

	deleteOwnerPropertyDetails(propertyLeadProfileId, ownerLeadProfileId): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/ownerlead-propertylead/${propertyLeadProfileId}/${ownerLeadProfileId}`).pipe();
	}

	delete(developmentId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${developmentId}`);
	}

	deleteRelationshipOfPropertyLeadAndOwnerLeadProfile(ownerLeadProfileId: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/ownerlead-propertylead/${ownerLeadProfileId}`);
	}

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-all`).pipe(retry({ count: 2, delay: 1500 }));
	}

	getFunnelCounts(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/funnel-counts`).pipe(retry({ count: 2, delay: 1500 }));
	}

	getFilterData(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/filterData`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findAllByDate(ownerLeadProfile): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/find-all-by-date`, ownerLeadProfile);
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: params }).pipe(retry({ count: 2, delay: 1500 }));

	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	audit(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/audit`).pipe(retry({ count: 2, delay: 1500 }));
	}

	importOwnerLeadProfile(contactdata: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(contactdata));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/import`, contactdata);
	}

	createOwnerLeadFromPropertyLead(propertyLeadProfileId: any): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/create-owner-lead-from-property-lead/${propertyLeadProfileId}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	findAllFiltered(activeOnly: boolean, agentUserId?: number): Observable<any> {
		let params = new HttpParams();
		if (activeOnly) params = params.set('activeOnly', 'true');
		if (agentUserId) params = params.set('agentUserId', agentUserId.toString());
		return this.http.get(`${environment.apiUrl}/${this.urlEndpoint}/find-all`, { params });
	}

	getPipelineMetrics(windowDays: number): Observable<any> {
		const params = new HttpParams().set('windowDays', windowDays.toString());
		return this.http.get(`${environment.apiUrl}/bizdev/pipeline-metrics`, { params });
	}

	getVelocityMetrics(windowDays: number = 90): Observable<any> {
		const params = new HttpParams().set('windowDays', windowDays.toString());
		return this.http.get(`${environment.apiUrl}/bizdev/velocity-metrics`, { params });
	}

	bulkUpdate(payload: { ids: number[]; updateField: 'STATUS' | 'AGENT'; leadStatus?: number; agentUserId?: number }): Observable<any> {
		return this.http.patch<any>(`${environment.apiUrl}/${this.urlEndpoint}/bulk-update`, payload);
	}

	compose(payload: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/bizdev/compose`, payload);
	}

	getLeadMessages(ownerLeadProfileId: number): Observable<ApiResponse> {
		const params = new HttpParams().set('ownerLeadProfileId', String(ownerLeadProfileId));
		return this.http.get<ApiResponse>(`${environment.apiUrl}/bizdev/messages`, { params }).pipe(retry({ count: 1, delay: 1500 }));
	}

	getMyTeamUserIds(): Observable<any> {
		return this.http.get<any>(`${environment.apiUrl}/bizdev/my-team-user-ids`).pipe(retry({ count: 1, delay: 1500 }));
	}

}
